import api, { APIClient } from "./api";

export default class AutomationsService extends APIClient {

	constructor(props: any) {
		super(props);
	}

	async GetAutomations() {
		const url = `${this.endpoint}/api/Automations/RetrieveList?refresh=${Math.random()}`;
		return api({
			method: 'get',
			url,
		})
	}

	async GetTemplates() {
		const url = `${this.endpoint}/api/Automations/GetTemplates?refresh=${Math.random()}`;
		return api({
			method: 'get',
			url,
		})
	}

	async GetAutomationRunHistory(id: number) {
		const url = `${this.endpoint}/api/Automations/GetHistory/${id}`;
		return api({
			method: 'get',
			url,
		})
	}

	async RemoveAutomations(id: number) {
		const url = `${this.endpoint}/api/Automations/Remove/${id}`;
		return api({
			method: 'delete',
			url,
		})
	}

	async GetResources(provider: number) {
		const url = `${this.endpoint}/api/Automations/GetResources?provider=${provider}`;
		return api({
			method: 'get',
			url,
		})
	}

	async CreateAutomation(newAutomation: any) {
		const url = `${this.endpoint}/api/Automations/Save`;
		return api({
			method: 'post',
			url,
			data: newAutomation,
			headers: {
				'Content-Type': 'application/json'
			}
		})
	}

	async UpdateAutomation(editAutomation: any) {
		const url = `${this.endpoint}/api/Automations/Update`;
		return api({
			method: 'put',
			url,
			data: editAutomation,
			headers: {
				'Content-Type': 'application/json'
			}
		})
	}

	async GetAuditRecords(automationId: number) {
		const url = `${this.endpoint}/api/Automations/Audit?automationId=${automationId}`;
		return api({
			method: 'get',
			url,
		})
	}
}